module.exports = __webpack_public_path__ + "static/media/leaflet.2f524850.png";